import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home/home.vue'
import homeMonterrey from '../views/homemonterrey/homemonterrey.vue'
import reset from '../views/reset/reset.vue'
Vue.use(VueRouter);


const routes = [
  {
    path:'/',
    name:'home',
    component:home,
  },
  {
    path:'/monterrey',
    name:'homemonterrey',
    component:homeMonterrey,
  },
  {
    path: '/reset',
    name: 'reset',
    component: reset,
  },
  {
    path: '*',
    redirect: '/'
  }
];

export const router = new VueRouter({
  base: '/',
  routes
});



